import CertsHeader from './CertsHeader';

export default CertsHeader;
